'use strict';

import {
    BufferAttribute,
    BufferGeometry, Mesh,
    OrthographicCamera,
    RGBFormat, Scene,
    Vector2,
    WebGLRenderTarget,
} from 'three';
import { projectMode } from '../../settings';


const defaultVertex = `
void main() {
    gl_Position = vec4(position, 1.0);
}
`;

const defaultFragment = `
    uniform sampler2D uScene;
    uniform vec2 uResolution;

    void main() {
        vec2 uv = gl_FragCoord.xy / uResolution.xy;
        vec3 color = vec3(uv, 1.0);
        color = texture2D(uScene, uv).rgb;

        // Do your cool postprocessing here
        color.r += sin(uv.x * 50.0);


        gl_FragColor = vec4(color, 1.0);
    }
`;

export class PostFX {

    #vertices = new Float32Array([
        -1.0, -1.0,
        3.0, -1.0,
        -1.0, 3.0
    ]);

    static #instances = [];
    static #active = false;

    constructor (name,renderer,shaderMaterial) {
        this.name = name;
        this.renderer = renderer;
        this.active = false;
        this.scene = new Scene();
        this.camera = new OrthographicCamera();
        this.geometry = new BufferGeometry();

        this.geometry.setAttribute('position',new BufferAttribute(this.#vertices,2));

        this.resolution = new Vector2();
        this.renderer.getDrawingBufferSize(this.resolution);

        this.target = new WebGLRenderTarget(this.resolution.x, this.resolution.y, {
           format: RGBFormat,
           stencilBuffer: false,
           depthBuffer: true
        });

        this.material = shaderMaterial;
        this.material.uniforms.uScene = {
            value: this.target.texture
        };
        this.material.uniforms.uResolution = {
            value: this.resolution
        };

        this.layer = new Mesh(this.geometry,this.material);
        this.layer.frustumCulled = false;
        this.scene.add(this.layer);

        PostFX.#instances.push(this);

        return this;
    }

    render(scene,camera,additionalRenderFunctions = () => {}) {
        if (!this.active) return;

        this.renderer.setRenderTarget(this.target);
        this.renderer.render(scene,camera);
        additionalRenderFunctions();
        this.renderer.setRenderTarget(null);
        this.renderer.render(this.scene,this.camera);
    }

    disable() {
        this.active = false;
    }

    enable() {
        this.active = true;
    }

    dispose() {
        this.active = false;

        PostFX.#instances = PostFX.#instances.filter(instance => instance.name !== this.name);

        Object.keys(this).forEach(key => {
           if (typeof this[key].dispose === 'function' && !this[key].isScene) {
               this[key].dispose();
           }
           this[key] = null;
        });
    }

    resize() {
        this.renderer.getDrawingBufferSize(this.resolution);
        this.target.setSize(this.resolution.x,this.resolution.y);
        this.material.uniforms.uResolution.value.set(this.resolution.x,this.resolution.y);
    }

    static render(scene,camera,additionalRenderFunctions) {

        for (let i = 0; i < PostFX.#instances.length; i++){
            PostFX.#instances[i].render(scene,camera,additionalRenderFunctions);
        }
    }

    static resize() {

        for (let i = 0; i < PostFX.#instances.length; i++){
            PostFX.#instances[i].resize();
        }
    }

    static enable() {
        if (PostFX.#instances.length === 0) return;

        PostFX.#active = true;
    }

    static disable() {
        PostFX.#active = false;
        PostFX.#instances.forEach(instance => instance.disable());
    }

    static isActive() {
        return PostFX.#active;
    }

    // static getInstances() {
    //     return PostFX.#instances;
    // }

    static effectToggle(name,state) {
        const effect = PostFX.#instances.find(instance => instance.name === name);
        if (effect){

            switch (state) {
                case 'enable':
                    effect.enable();
                    break;
                case 'disable':
                    effect.disable();
                    break;
            }
        }
    }

    static dispose(name) {
        const effect = PostFX.#instances.find(instance => instance.name === name);
        effect && effect.dispose();

        if (PostFX.#instances.length === 0){
            PostFX.disable();
        }


    }
}


window.pfx = PostFX;